/**
 * Lightweight top-level Line names + equipment counts for chat suggested
 * prompts. Not a Plant Viewer landing drain — chat only needs a handful
 * of real names, and a full `getPlantSites` + per-site detail fan-out
 * is more than that surface should pay.
 *
 * Top-level = a `:Line` that is not a `HAS_SUBLINE` child. Equipment
 * counts walk `HAS_SUBLINE*0..` then `HAS_EQUIPMENT*1..8` so nested
 * tooling still ranks a line above an empty stray.
 *
 * Bounded by a literal `LIMIT` because chat needs a handful of real
 * names, not the whole inventory.
 */
export const PLANT_LINE_INVENTORY_LIMIT = 8

export const PLANT_LINE_INVENTORY_CYPHER = `
            MATCH (l:Line)
            WHERE NOT ()-[:HAS_SUBLINE]->(l)
            OPTIONAL MATCH (l)-[:HAS_SUBLINE*0..]->(scope:Line)
            OPTIONAL MATCH (scope)-[:HAS_EQUIPMENT*1..8]->(eq:Equipment)
            WITH l, count(distinct eq) AS equipmentCount
            RETURN l.id AS id,
                   coalesce(l.name, l.id) AS name,
                   equipmentCount
            ORDER BY equipmentCount DESC, toLower(coalesce(l.name, l.id))
            LIMIT ${PLANT_LINE_INVENTORY_LIMIT}
          `
